<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-row>
            <b-col>
              <div class="text-center">
                <span class="txt-home-title-part1">Free </span>
                <span class="txt-home-title-part2">Online Dental CE</span>
              </div>
              <div class="mt-3 text-center txt-home-subtitle">
                Earn live, interactive and self-study
                <br>dental continuing education credits
              </div>
              <div class="mt-4 text-center">
                  <img src="@/art/home_ce_laptop_icon.png" class="fluid" style="max-width:100px;" />
              </div>
            </b-col>
          </b-row>

          <searchbar v-model="searchModel" @remove-filter="removeFilter"></searchbar>

          <div class="div-section-ad" v-if="featuredClass !== null">
            <!-- Featured PREMium Class -->
            <vpfeaturedcontent :fc=featuredClass :fp=null :fb=null :fh=featuredHash></vpfeaturedcontent>
          </div>

          <!-- LIVE WEBINARS -->
          <div class="div-section-header" v-if="webinars.length !== 0">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Free Live Dental CE Webinars</span>
                </div>
              </b-col>
              <b-col cols="8">
                  <span class="txt-section-subtitle">Showing Next {{webinars.length}} Upcoming</span>
              </b-col>
              <b-col cols="4" class="text-right">
                  <b-link class="txt-section-subtitle" to="/upcoming">Show All</b-link>
              </b-col>
            </b-row>
          </div>

          <div class="div-section-body">
            <b-row v-for="(row,ix) in webinars" ref="rows" v-bind:key="row.classId" class="mt-3 mb-3 pointer" @click="gotoWebinar(ix,row)">
              <b-col cols="4" class="text-center">
                <b-img fluid v-bind:src="row.photo" />
                <div v-if="row.isReserved" class="text-center reserved">RESERVED</div>
                <div v-if="row.isWaiting" class="text-center waitlist">WAITLIST</div>
              </b-col>
              <b-col cols="8" style="margin-left: -20px;">
                <div class="class-title">{{row.className}}</div>
                <div class="class-details">
                  {{row.speakerName}}
                  <br>{{row.sponsorCompanyName}}
                  <span class="red">
                    <br>{{row.releaseDateUTC | prettyDateTime}}
                    <br>{{row.credits}} CEU ({{row.creditName}})
                  </span>
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- ONDEMAND WEBINARS -->
          <div class="div-section-header" v-if="classes.length !== 0">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">On-Demand CE Webinars</span>
                </div>
              </b-col>
              <b-col cols="8">
                  <span class="txt-section-subtitle">Showing {{classes.length}} Newest</span>
              </b-col>
              <b-col cols="4" class="text-right">
                  <b-link class="txt-section-subtitle" to="/ondemand">Show All</b-link>
              </b-col>
            </b-row>
          </div>

          <div class="div-section-body">
            <b-row v-for="row in classes" v-bind:key="row.classId" class="mt-3 mb-3 pointer" @click="gotoClass(row.slug)">
                <b-col cols="4" class="text-center">
                  <b-img fluid v-bind:src="row.photo" />
                  <div v-if="row.examTaken" class="text-center completed">COMPLETED</div>
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                  <div class="class-title">{{row.className}}</div>
                  <div class="class-details">
                    {{row.speakerName}}
                    <br>Sponsor: {{row.sponsorCompanyName}}
                    <br>{{row.releaseDateUTC | prettyDate}} - {{row.credits}} CEU ({{row.creditName}})
                  </div>
                  <div class="mt-2" v-if="false">
                    <b-button :to="{ path: constants.PATHS.ON_DEMAND_BASE + '/' + row.slug }">Enter Classroom</b-button>
                  </div>
                </b-col>
            </b-row>
          </div>

          <!-- PODCASTS -->
          <div class="div-section-header" v-if="podcasts.length !== 0">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Dental Podcasts</span>
                </div>
              </b-col>
              <b-col cols="8">
                  <span class="txt-section-subtitle">Showing {{podcasts.length}} Newest</span>
              </b-col>
              <b-col cols="4" class="text-right">
                  <b-link class="txt-section-subtitle" to="/podcasts">Show All</b-link>
              </b-col>
            </b-row>
          </div>

          <div class="div-section-body">
            <b-row v-for="row in podcasts" v-bind:key="row.id" class="mt-3 mb-3 pointer" @click="gotoPodcast(row.podcastShowHash,row.hash)">
              <b-col cols="4" class="text-center">
                <b-img fluid v-bind:src="row.photo" />
                <div v-if="row.examTaken" class="text-center completed">COMPLETED</div>
              </b-col>
              <b-col cols="8" style="margin-left: -20px;">
                <div class="class-title">{{row.title}}</div>
                <div class="class-details">
                  {{row.speakerName}}
                  <br>Sponsor: {{row.companyName}}
                  <br>{{row.releaseDateUTC | prettyDate}}<span v-if="row.credits > 0"> - {{row.credits}} CEU (Self Study)</span>
                  <br><b-icon icon="clock"></b-icon>&nbsp;{{row.durationSec | prettySeconds }}
                </div>
              </b-col>
            </b-row>
          </div> <!-- podcasts -->

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";
import utils from "@/utils/utils";
import constants from "@/config/constants"

export default {
  name: "Home",
  data() {
    return {
      debug: false,
      error: false,
      loading: true,
      msg: 'Home',
      blurb: '',
      webinars: [],
      classes: [],
      podcasts: [],
      featuredClass: null,  // premium class
      featuredHash: null,
      studentData: {status: false},
      studentHash: this.$root.getToken() || '',
      seats: [],   // reserved seats
      bannerAds: [],
      searchModel: {
        path: '/search',
        label: 'Search All Content',
        catId: null,
        compId: null,
        query: null
      }
    }
  },
  props: {},
  computed: {},
  methods: {
    gotoWebinar(ix, row) {
      if (row.isReserved || row.isWaiting) {
        this.$router.push(`/live/${row.hash}`)
      }
      else {
        this.$router.push(`/reserve/${row.hash}`)
      }
    },
    gotoClass(hash) {
      this.$router.push(`${constants.PATHS.ON_DEMAND_BASE}/${hash}`)
    },
    gotoPodcast(ps,p) {  // podcastShowHash, podcastHash
      this.$router.push(`/podcast/${ps}/${p}`)
    },
    removeFilter() {
      // never called on home. placeholder.
      this.searchModel.catId = null
      this.searchModel.compId = null
      this.searchModel.query = null
    },
    doHome() {
      this.loading = true
      this.webinars = []
      this.classes = []
      this.podcasts = []

      this.featuredClass = null
      this.featuredHash = null

      service
        .getHome(this.studentHash)
        .then(
          (res => {
            // console.log(`back from getHome`);
            if (this.debug) console.log(res);
            if (res.status) {
              this.$root.setVersionApi(res.version)
              if (res.webinars.status) {
                this.webinars = res.webinars.data
                this.seats = res.webinars.seats
                this.webinars.forEach( (row,ix) => this.webinars[ix].isReserved = row.hasSeat && !row.isWaiting )
                // below works too, but doesn't need seats[]
                // this.webinars.forEach( (row,ix) => this.webinars[ix].isReserved = this.seats.includes(row.classId) && !row.isWaiting )
              }
              if (res.featuredContent.status) {
                this.featuredClass = (res.featuredContent.featuredClass) ? res.featuredContent.featuredClass.data[0] : null
                this.featuredHash = res.featuredContent.featuredHash
              }
              if (res.classes.status) this.classes = res.classes.data
              if (res.podcasts.status) this.podcasts = res.podcasts.data
              // this.bannerAds = res.bannerAds.bannerAds
              // this.blurb = `All episodes from this series (${this.podcasts.length})`
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false;
        })
        .catch(e => {
          this.error = true;
          console.log(e);
        });
      // this.error = this.$root.getClassId() === 0;

      }
  },
  created() {
    this.doHome()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.txt-home-title-part1 {
  font-weight: bold;
  color: #939393;
  font-size: 2rem;
}
.txt-home-title-part2 {
  /* font-weight: bold; */
  color: #3471b3;
  font-size: 1.9rem;
}
.txt-home-subtitle {
  font-weight: bold;
  font-size: 1.1rem;
  line-height: 130%;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue